/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'people.menu.renotify.flag.description': 'A gente está mandando um lembrete para todos. Pode levar até um minuto.',
  'people.menu.renotify.flag.description.confluence': 'Lembrar colegas de equipe',
  'people.menu.renotify.flag.title': 'Enviando lembretes',
  'people.menu.renotify.flag.title.confluence': 'Reenviando o e-mail de convite',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} pessoa não aceitou o convite para {product}. Saiba quem está faltando e envie um lembrete.} other {{userCount,number} pessoas não aceitaram o convite para {product}. Saiba quem está faltando e envie um lembrete.}}',
  'people.menu.renotify.menu.description.confluence':
    'Algumas pessoas não aceitaram o convite para o Confluence. Saiba quem está faltando e envie um lembrete.',
  'people.menu.renotify.menu.dismiss': 'Ignorar',
  'people.menu.renotify.menu.dismiss.confluence': 'Agora não',
  'people.menu.renotify.menu.remind': 'Lembrar membros da equipe',
  'people.menu.renotify.menu.remind.confluence': 'Lembrar colegas de equipe',
  'people.menu.renotify.menu.title': 'Todos estão participando?',
  'people.menu.renotify.modal.copied': 'Link copiado',
  'people.menu.renotify.modal.copy': 'Copiar link do convite',
  'people.menu.renotify.modal.description':
    'A gente pode mandar um lembrete aos membros ausentes ou você pode compartilhar o link de convite com eles.',
  'people.menu.renotify.modal.description.confluence':
    'Envie o e-mail de convite de novo ou copie e compartilhe o link do convite.',
  'people.menu.renotify.modal.dismiss': 'Cancelar',
  'people.menu.renotify.modal.resend': 'Enviar lembrete',
  'people.menu.renotify.modal.resend.confluence': 'Reenviar convite',
  'people.menu.renotify.modal.title': 'Lembre os membros ausentes',
  'people.menu.renotify.modal.title.confluence': 'Lembre os colegas de equipe que faltam',
  'ptc.pm.collaborators.title': 'Seus colaboradores',
  'ptc.pm.error-heading': 'Algo de errado aconteceu',
  'ptc.pm.error-image-alt-text': 'Um robô quebrado e várias pessoas ocupadas em seu conserto.',
  'ptc.pm.error-text':
    'Nós acompanhamos esses erros, mas não hesite em entrar em contato se a atualização não corrigir as coisas',
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} membro} other {{memberCount,number} membros}}',
  'ptc.pm.people': 'Pessoas',
  'ptc.pm.teams': 'Equipes',
  'ptc.pm.view-your-profile': 'Exibir seu perfil',
  'ptc.pm.your-teams.title': 'Suas equipes',
};
